<template>
  <div class="ccontainer ccontainer-icon">
    <button class="toolbox-button">
      <div>
        <div 
          class="toolbox-icon"
          @click="open_modal = true"
          :data-tooltip="$t('tokens_modal.button_send_tokens_tooltip')"
        >
          <div class="jitsi-icon jitsi-icon-default">
            <div class="icon"></div>
          </div>
        </div>
      </div>
    </button>
    <SendTokensVideoCallRoomModal
      v-show="open_modal"
      @cancel="open_modal = false"
      @tokensSended="$emit('tokensSended', $event)"
    />
  </div>
</template>

<script>
import SendTokensVideoCallRoomModal from "../../../components/SendTokensVideoCallRoomModal";

export default {
  components: {
    SendTokensVideoCallRoomModal,
  },
  data() {
    return {
      open_modal: false,
    };
  },
};
</script>
<style scoped lang="scss">
@import "../jisti.scss";
@import "../../../styles/variables";

.button {
  /*width: 50px;
  height: 20px;*/
  border-radius: 5px;
  text-align: center;
  /*background: #cccccc;*/
  cursor: pointer;
  // margin-bottom: 5px;
  overflow: hidden;
  font-weight: bold;
}

.icon {
  vertical-align: bottom;

  $SIZE: 36px;

  width: $SIZE;
  height: $SIZE;
  background-size: contain;
  // background-repeat: no-repeat;
  background-position: center;
  background-image: var(--img-btn-min-dolar);
}

.button:hover::before,
.button:active::before,
.button:focus::before {
  content: attr(data-tooltip);
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
  background-color: black;
  color: white;
  border-radius: 0.5rem;
  padding: 0.3rem 0.5rem;
  font-size: 0.8rem;
}
</style>
